/**
 * HTTP 401 Unauthorized Error.
 */
export class UnauthorizedError extends Error {
  constructor () {
    super('Unauthorized')
    this.name = this.constructor.name
  }
}
